import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import TaskIcon from '@mui/icons-material/Task';
import DialogActions from '@mui/material/DialogActions';
import AddIcon from '@mui/icons-material/Add';
import axios from '../../../../api/axios';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FormControl } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useAuthContext } from '../../../../context/AuthContext';

const URL = "./employeeInformation";

function AddMember({ open, setOpen, isAddButton, rowData, setRefreshData, trackno }) {
  const { user_email } = useAuthContext();
  const navigate = useNavigate();
  // const { state } = useLocation();
  // New state variables
  const [id, setId] = useState('');
  const [memberID, setMemberID] = useState('');
  const [Name, setName] = useState('');
  const [fathersName, setFathersName] = useState('');
  const [adharNo, setAdharNo] = useState('');
  const [dob, setDob] = useState('');
  const [joinDate, setJoinDate] = useState('');
  const [retirementDate, setRetirementDate] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [department, setDepartment] = useState('');
  const [nominee, setNominee] = useState('');
  const [age, setAge] = useState('20');
  const [DepartmentList, setDepartmentList] = useState([]);

  const [alertOpen, setAlertopen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');
  // const { value, type } = state;

  const handleClick = () => {
    setAlertopen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertopen(false);
  };

  const serviceMethod = async (mainURL, method, data, handleSuccess, handleException) => {
    try {
      const response = await axios.post(mainURL, data);
      return handleSuccess(response.data);
    } catch (err) {
      if (!err?.response) {
        console.log("No server response");
      } else {
        return handleException(err?.response.data);
      }
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const data = {
      memberID,
      Name,
      fathersName,
      adharNo,
      dob,
      joinDate,
      mobileNo,
      department,
      nominee,
      age
    };


    // Check for empty values, excluding `memberID`
    for (const [key, value] of Object.entries(data)) {
      if (key !== 'memberID' && !value) {
        alert(`Please fill out the ${key} field.`);
        return false; // Exit the function if any required value is empty
      }
    }

    if (isAddButton) {
      const mainURL = URL + '/add';
      serviceMethod(mainURL, 'POST', data, handleSuccess, handleException);
    } else {
      const mainURL = URL + '/' + id + '/update';
      serviceMethod(mainURL, 'POST', data, handleSuccess, handleException);
    }
  };

  const handleSuccess = (data) => {
    setSeverity("success");
    setMessage(data.message);
    setAlertopen(true);
    setTimeout(() => {
      // navigate("/viewMember");
      setOpen(false);
      setRefreshData((oldValue) => !oldValue);
    }, 2000); // Matches autoHideDuration
  }

  useEffect(() => {
    setOpen(open);
    setAlertopen(false);
    if (isAddButton) {
      loadDepartmentData();
      setMemberID('');
      setName('');
      setFathersName('');
      setAdharNo('');
      setDob('');
      setJoinDate('');
      setMobileNo('');
      setDepartment('');
      setNominee('');
      setAge('');
    } else {
      loadDepartmentData();
      loadData(rowData);
    }

  }, [isAddButton, rowData]);

  const loadData = (rowData) => {
    console.log(rowData);
    setId(rowData.id);
    setMemberID(rowData.memberID || '');
    setName(rowData.Name || '');
    setFathersName(rowData.fathersName || '');
    setAdharNo(rowData.adharNo || '');
    setDob(rowData.dob || '');
    setJoinDate(rowData.joinDate || '');
    setMobileNo(rowData.mobileNo || '');
    setDepartment(rowData.department || '');
    setRetirementDate(rowData.retirementDate || '');
    setNominee(rowData.nominee || '');
    setAge(rowData.age || '');

  };

  const loadDepartmentData = async () => {
    try {
      const response = await axios.get("/department");
      setDepartmentList(response.data.message || []);
      console.log("department", response);
    } catch (err) {
      if (!err?.response) {
        console.log("No server response");
      } else {
        console.log(err?.response.data);
      }
    }
  };

  const getAge = (event) => {
    console.log(event.target.value);
    const dobDT = new Date(event.target.value); // Get the date from input
    const todayDT = new Date(); // Current date
    let ageNW = todayDT.getFullYear() - dobDT.getFullYear(); // Calculate year difference

    // Adjust if birthday hasn't occurred yet this year
    const isBirthdayPassed =
      todayDT.getMonth() > dobDT.getMonth() ||
      (todayDT.getMonth() === dobDT.getMonth() && todayDT.getDate() >= dobDT.getDate());

    if (!isBirthdayPassed) {
      ageNW--;
    }

    setAge(ageNW);
  }






  const handleException = (data) => {
    setSeverity("error");
    setMessage(data.message);
    setAlertopen(true);
  }

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        sx={{ '& .MuiDialog-paper': { width: '100%', maxHeight: '100%' } }}
        open={open}
      >
        <DialogTitle
          sx={{
            color: 'navy', // Text color (affects the outline for outlined buttons)
            borderColor: 'navy', // Outline color
            '&:hover': {
              borderColor: 'darkblue', // Darken the outline on hover
            },
          }}>
          {isAddButton ? "Add Member" : "Edit Member"}
        </DialogTitle>
        <DialogContent>
          <div style={{ marginTop: '0px', padding: '0px' }}>
            <Box
              component="main"
              sx={{
                flexGrow: 1,
                p: 3,
                border: '1px solid rgb(229 231 235 / 99%);',
                borderRadius: '8px',
              }}
            >
              <Toolbar />

              <br />
              <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <FormControl fullWidth>
                  <Typography variant="subtitle2">Member ID</Typography>
                  <TextField                 
                    margin="normal"
                    required
                    fullWidth
                    id="memberID"
                    value={memberID}
                    onChange={(e) => setMemberID(e.target.value)}
                    sx={textfieldStyles}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <Typography variant="subtitle2">Name</Typography>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="Name"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    sx={textfieldStyles}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <Typography variant="subtitle2">Father's Name</Typography>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="fathersName"
                    value={fathersName}
                    onChange={(e) => setFathersName(e.target.value)}
                    sx={textfieldStyles}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <Typography variant="subtitle2">Nominee's Name</Typography>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="fathersName"
                    value={nominee}
                    onChange={(e) => setNominee(e.target.value)}
                    sx={textfieldStyles}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <Typography variant="subtitle2">Adhar No</Typography>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="adharNo"
                    value={adharNo}
                    onChange={(e) => setAdharNo(e.target.value)}
                    sx={textfieldStyles}
                  />
                </FormControl>
              </Stack>
              <br />
              <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <FormControl fullWidth>
                  <Typography variant="subtitle2">DOB</Typography>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    type="date" // This makes the field accept only dates
                    id="dob"
                    value={dob}
                    onChange={(e) => {
                      setDob(e.target.value)
                      getAge(e);
                    }}
                    sx={textfieldStyles}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <Typography variant="subtitle2">Join Date</Typography>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    type="date" // This makes the field accept only dates
                    id="joinDate"
                    value={joinDate}
                    onChange={(e) => setJoinDate(e.target.value)}
                    sx={textfieldStyles}
                  />

                </FormControl>

                <FormControl fullWidth>
                  <Typography variant="subtitle2">Retirement Date</Typography>
                  <TextField
                    margin="normal"
                    disabled
                    required
                    fullWidth
                    type="date" // This makes the field accept only dates
                    id="joinDate"
                    value={retirementDate}
                    onChange={(e) => setRetirementDate(e.target.value)}
                    sx={textfieldStyles}
                  />

                </FormControl>
                <FormControl fullWidth>
                  <Typography variant="subtitle2">AGE</Typography>
                  <TextField
                    margin="normal"
                    disabled
                    required
                    fullWidth
                    // type="date" // This makes the field accept only dates
                    id="joinDate"
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    sx={textfieldStyles}
                  />

                </FormControl>

                <FormControl fullWidth>
                  <Typography variant="subtitle2" sx={{ minHeight: 24, lineHeight: 1.5 }}>Mobile No</Typography>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="mobileNo"
                    value={mobileNo}
                    onChange={(e) => {
                      const input = e.target.value;
                      // Only allow numbers and limit to 10 digits
                      if (/^\d{0,10}$/.test(input)) {
                        setMobileNo(input);
                      }
                    }}
                    inputProps={{
                      maxLength: 10, // Maximum 10 digits
                      inputMode: 'numeric', // Mobile-friendly numeric keyboard
                      pattern: '[0-9]*' // Allows only numbers
                    }}
                    sx={textfieldStyles}
                  />
                </FormControl>

                <FormControl fullWidth>
                  <Typography variant="subtitle2" sx={{ minHeight: 24, lineHeight: 1.5 }}>Department</Typography>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 200,
                        },
                      },
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'lightgray',
                        },
                        '&:hover fieldset': {
                          borderColor: 'lightgray',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'lightgray',
                        },
                      },
                    }}
                  >
                    <MenuItem value="">
                      <em>Please Select Department</em>
                    </MenuItem>
                    {DepartmentList.map((department, index) => (
                      <MenuItem key={index} value={department.id}>
                        {department.departmentName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
              <br />
              <DialogActions sx={{ margin: '10px' }}>
                <Button
                  size="large"
                  variant="outlined"
                  sx={{
                    color: 'navy',
                    borderColor: 'navy',
                    '&:hover': {
                      borderColor: 'darkblue',
                    },
                  }}
                  autoFocus
                  onClick={(e) => {
                    setOpen(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  size="large"
                  variant="contained"
                  onClick={handleSave}
                  sx={{
                    backgroundColor: '#0d2365',
                    color: 'white',  // Change background color to purple
                    '&:hover': {
                      backgroundColor: '#0d2365',  // Darken the color on hover
                    },
                    borderRadius: '10px'
                  }}

                  type="Button"
                >
                  {isAddButton ? "Add" : "Update"}
                </Button>
              </DialogActions>
              <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose}>
                <Alert
                  onClose={handleClose}
                  severity={severity}
                  variant="filled"
                  sx={{ width: '100%' }}
                >
                  {message}
                </Alert>
              </Snackbar>
            </Box>
          </div>
        </DialogContent>

      </Dialog>


    </>
  );
}

const textfieldStyles = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'lightgray', // Default border color
    },
    '&:hover fieldset': {
      borderColor: 'lightgray', // Remove hover border color
    },
    '&.Mui-focused fieldset': {
      borderColor: 'lightgray', // Remove focus border color
    },
  },
};

export default AddMember;
